import React from 'react';
import i18n from 'i18next';

// Error screen shown when login cannot complete. Used by the callback page and
// by /login when it refuses to redirect to LUC again (see loginLoopGuard).
// "Try again" is always a user-initiated action.
export const AuthError = ({ message, onTryAgain }) => (
  <div className='text-center py-5' role='alert'>
    <h4>{i18n.t('ERROR')}</h4>
    <p className='my-3'>{message}</p>
    <button
      type='button'
      className='btn btn-primary btn-sm'
      onClick={onTryAgain}
    >
      {i18n.t('TRYAGAIN')}
    </button>
  </div>
);
